import { useRegisterDockRightSlot } from './context/DockRightSlotContext';

import type { ReactElement } from 'react';

import styles from './scss/DockRightSlot.module.scss';

/**
 * Marks where the free space splits for a panel docked to the right.
 *
 * Placed as a flex sibling of the page's main content, after it, so a docked panel's own width
 * sizes this box and the main content shrinks by the same amount for free. Empty, it takes no
 * space at all.
 */
function DockRightSlot(): ReactElement {
  const setSlot = useRegisterDockRightSlot();

  return <div ref={setSlot} className={styles.slot} />;
}

export default DockRightSlot;
